







import { listFactory } from '@/main/pages';
import { PageMode } from '@/main/utils/pageMode';

import { openEdit } from '@/main/router/routerPath';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { id: event.data.ID });
		},
	},
});
